import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';

export interface HardResetModalState {
    isOpen: boolean;
    stationId: string;
}

const initialState: HardResetModalState = {
    isOpen: false,
    stationId: '',
};

export const slice = createSlice({
    name: 'hardResetModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setstationId: (state, action: PayloadAction<string>) => {
            state.stationId = action.payload;
        },
    },
});

export const { setOpen, setstationId } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) => state.hardResetModal.isOpen;
export const selectStationId = (state: RootState) =>
    state.hardResetModal.stationId;

export default slice.reducer;
